import * as React from "react";
import clsx from "clsx";
import { Button, Typography } from "@mui/material";

import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles({
  centerContactButton: {
    height: 40,
    margin: "10px auto 0 auto",
    display: "table",
    textTransform: "none",
    fontSize: "14px",
  },
  feedbackLink: {
    marginTop: "1rem",
    marginBottom: "1rem",
  },
});

interface Props {
  appName: string;
  cert?: string;
}

function LinkComponent({ appName, cert }: Props) {
  const classes = useStyles();

  const link = (
    <>
      {cert ? (
        <Button
          variant="outlined"
          id="contact-button"
          color="primary"
          className={clsx("contact-button", classes.centerContactButton)}
          onClick={() =>
            (window.location.href = `https://ask.fdic.gov/fdicinformationandsupportcenter/s/fdicdirform?app=${appName}&cert=${cert}`)
          }
        >
          Contact the FDIC
        </Button>
      ) : (
        <Typography variant="body2" className={classes.feedbackLink}>
          {" "}
          Provide{" "}
          <a
            id="feedback-link"
            href={`https://ask.fdic.gov/fdicinformationandsupportcenter/s/fdicdirform?app=${appName}`}
          >
            feedback or submit a question
          </a>{" "}
          about this page.
        </Typography>
      )}
    </>
  );
  return link;
}

export default LinkComponent;
